"use client";
import { useState } from "react";
import { signIn } from "next-auth/react";
import { hooks, providers } from "@lib/client";
import logjs from "@metrojs/logjs";
const { useWebAppContext } = providers;

const log = new logjs("login/useLogin");

/** 当日ログイン失敗回数上限時（failure-check で canLogin: false）のアラート文言 */
const LOGIN_ATTEMPT_LIMIT_ALERT =
  "アカウントがロックされました<br/>解除される場合は事務局に連絡してください";

export function useLogin() {
  const { actions } = useWebAppContext();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form, formProps] = hooks.useFormEx();
  const login = async (mode) => {
    try {
      setIsLoading(true);
      setError(null);

      log.debug("ログイン処理開始", { form });

      const loginId = String(form.login_id ?? "").trim();
      if (loginId) {
        try {
          const res = await fetch("/api/login/failure-check", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ login_id: loginId }),
          });
          if (res.ok) {
            const status = await res.json();
            log.debug("loginFailureStatus", status);
            if (status.canLogin === false) {
              if (typeof actions?.showAlert === "function") {
                actions.showAlert(LOGIN_ATTEMPT_LIMIT_ALERT);
                setError(status.message || "ユーザ名かパスワードが違います");
              } else {
                setError(status.message || "ユーザ名かパスワードが違います");
              }
              return;
            }
          }
        } catch (err) {
          log.warn("login failure-check skipped", err);
        }
      }

      const result = await signIn("credentials", {
        login_id: form.login_id,
        password: form.password,
        mode: mode,
        redirect: false,
        callbackUrl: "/agreement", //Consts.ROUTES.HOME,
      });

      log.debug("ログイン結果", { result });

      if (result?.error) {
        // NextAuthのエラーメッセージを日本語に変換
        let errorMessage = "ログインに失敗しました";

        if (result.error === "CredentialsSignin") {
          log.debug(`6 : --------------------------------------------------------------`);
          errorMessage = "ログインIDまたはパスワードが正しくありません";
        } else if (result.error.includes("ログインIDまたはパスワードが正しくありません")) {
          errorMessage = result.error;
        }

        setError(errorMessage);
        return;
      }

      // ログイン成功時はリダイレクト
      //if (result?.ok) {
        //window.location.href = result.url || "/agreement"; //Consts.ROUTES.HOME;
        //router.push("/agreement"); //Consts.ROUTES.HOME;
      //}
      // ログイン成功時はリダイレクト
      if (result?.ok) {
        // セッション更新を待つため少し待機
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // セッションからnextViewを取得
        try {
          const sessionResponse = await fetch("/api/auth/session");
          const sessionData = await sessionResponse.json();
          const nextView = sessionData?.nextView || sessionData?.user?.nextView;
          
          log.debug("セッション取得結果", { nextView, sessionData });
          
          // nextViewに基づいてリダイレクト先を決定
          let redirectPath = "/agreement"; // デフォルト
          if (nextView === "bs_select") {
            redirectPath = "/bs_select";
          } else if (nextView === "kyoto_seibi_select") {
            redirectPath = "/kyoto_seibi_select";
          }
          
          log.debug("リダイレクト先決定", { redirectPath, nextView });
          window.location.href = redirectPath;
        } catch (sessionError) {
          log.error("セッション取得エラー", sessionError);
          // セッション取得に失敗した場合はデフォルトのリダイレクト先へ
          window.location.href = "/agreement";
        }
      }
    } catch (error) {
      log.error("ログインエラー", error);
      setError("ログインに失敗しました");
    } finally {
      setIsLoading(false);
    }
  };

  return [
    {
      ...form,
      error,
      loading: isLoading,
    },
    {
      ...formProps,
      login,
    },
  ];
}
